import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Container,
} from "@material-ui/core";
import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Page from "src/components/Page";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import { getRemarkStatus } from "src/redux/actions/purchaseRequest.action";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  chatSection: {
    width: "100%",
    height: "80vh",
  },
  headBG: {
    backgroundColor: "#e0e0e0",
  },
  borderRight500: {
    borderRight: "1px solid #e0e0e0",
  },
  messageArea: {
    height: "70vh",
    overflowY: "auto",
  },
}));

export default function RemarkStatusComponent() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();

  const { purchaseRequestRemarkStatus, purchaseRequest } = useSelector(
    (state) => state.purchaseRequestReducer
  );

  useEffect(() => {
    if (params.id) {
      dispatch(getRemarkStatus(params.id));
    }
    return () => {};
  }, [params.id]);

  return (
    <Page className={classes.root} title="Purchase Requisition List">
      <Container maxWidth={false}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            color="inherit"
            onClick={() => {
              history.replace("/purchase-requisition-list");
            }}
          >
            Purchase Requisition List
          </Link>
          <Link color="textPrimary" aria-current="page">
            Purchase Requisition All Remark ({params.prno})
          </Link>
        </Breadcrumbs>
        <Card>
          <CardHeader
            subheader="For the purchase requisition on the system."
            title="Purchase Requisition All Remark"
          />
          <Box display="flex" justifyContent="flex-end" p={2}>
            <Button
              color="primary"
              variant="contained"
              onClick={(e) => {
                e.preventDefault();
                history.replace(`/purchase-requisition-list`);
              }}
            >
              <ArrowBackIcon />
              Back
            </Button>
          </Box>
          <CardContent>
            <Grid container component={Paper} className={classes.chatSection}>
              <Grid item xs={12}>
                <List className={classes.messageArea}>
                  {purchaseRequestRemarkStatus.data &&
                    purchaseRequestRemarkStatus.data.map(
                      (i) =>
                        i.REMARK_TEXT && (
                          <ListItem key="1">
                            <Grid container>
                              <Grid item xs={12}>
                                <ListItemText
                                  align={
                                    Boolean(i.PR_STATUS === 40)
                                      ? `right`
                                      : `left`
                                  }
                                  secondary={
                                    Boolean(i.PR_STATUS === 40)
                                      ? `MANAGER REJECTED`
                                      : Boolean(i.PR_STATUS === 70)
                                      ? `PURCHASING  HOLD`
                                      : Boolean(i.PR_STATUS === 80)
                                      ? `PURCHASING REJECTED`
                                      : "NONE STATUS"
                                  }
                                ></ListItemText>
                              </Grid>
                              <Grid item xs={12}>
                                <ListItemText
                                  align={
                                    Boolean(i.PR_STATUS === 40)
                                      ? `right`
                                      : `left`
                                  }
                                >
                                  <Chip
                                    label={i.REMARK_TEXT}
                                    color={
                                      Boolean(i.PR_STATUS === 40)
                                        ? `primary`
                                        : `secondary`
                                    }
                                    variant="outlined"
                                  />
                                </ListItemText>
                              </Grid>
                              <Grid item xs={12}>
                                <ListItemText
                                  align={
                                    Boolean(i.PR_STATUS === 40)
                                      ? `right`
                                      : `left`
                                  }
                                  // secondary={moment()
                                  //   .utc(i.UPDATED_AT)
                                  //   .local("Asia/Bangkok")
                                  //   .format("YYYY-MM-DD HH:mm:ss")}
                                  secondary={i.UPDATED_AT}
                                ></ListItemText>
                              </Grid>
                            </Grid>
                          </ListItem>
                        )
                    )}
                </List>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
